module.exports = __webpack_public_path__ + "img/deskshelf05.adc20ee0.jpg";